import { Hero } from './Hero';
import { About } from './About';
import { Bonus } from './Bonus';
import { Services } from './Services';
import { Testimonial } from './Testimonial';
import { Onboarding } from './Onboarding';
import { BannerDownloadApp } from './BannerDownloadApp';
import { Promotion } from './Promotion';

export {
  Hero,
  About,
  Bonus,
  Services,
  Testimonial,
  Onboarding,
  BannerDownloadApp,
  Promotion,
};
